import { DateTime, Interval } from "luxon";
import Vue from "vue";

function createActions() {
  var actions = {};
  Object.keys(flink.attendee).forEach(f => {
    actions[f] = function({ commit }, args) {
      commit("loading", true, { root: true });
      return flink.attendee[f](args)
        .then(result => {
          if (Array.isArray(result)) {
            result.forEach(e => {
              commit("setById", { id: e.id, body: e });
            });
          } else {
            commit("setById", { id: result.id, body: result });
          }
          return result;
        })
        .then(result => {
          commit("loading", false, { root: true });
          return result;
        })
        .catch(err => {
          commit("loading", false, { root: true });
          throw err;
        });
    };
  });
  return actions;
}

function setFromJson(records, body) {
  const id = body.id;
  let newRecord = records[id] || {};
  newRecord = records[id] || {};
  newRecord.id = body.id;
  newRecord.firstName = body.firstName;
  newRecord.middleName = body.middleName;
  newRecord.email = body.email;
  newRecord.phone = body.phone;
  newRecord.event = body.event;
  newRecord.accessCodes = body.accessCodes;

  Vue.set(records, id, newRecord);
}

export default function() {
  return {
    namespaced: true,
    state: {
      attendees: {}
    },
    getters: {
      attendees: state => state.attendees,
      attendee: state => id => state.attendees[id]
    },
    mutations: {
      setById(state, { id, body }) {
        setFromJson(state.attendees, body);
      }
    },
    actions: createActions()
  };
}



// WEBPACK FOOTER //
// ./src/store/modules/attendees.js